
import { Box } from '@mui/material';

export default function ScanButton({
  size = 64,              
  bg = 'rgba(59,130,246,0.12)', 
  iconColor = '#2563EB',  
}: {
  size?: number;
  bg?: string;
  iconColor?: string;
}) {
  const iconSize = Math.round(size * 0.42);  
  const iconStroke = Math.max(2, Math.round(size * 0.04));

  return (
    <Box sx={{display:"flex", alignItems: 'center',
          justifyContent: 'center'} }>
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          backgroundColor: bg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 6px rgba(37, 99, 235, 0.15)',        
        }}
        aria-label="Scan"
        role="button"
      >
        
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
         
          <path
            d="M7 4H5a1 1 0 0 0-1 1v2M17 4h2a1 1 0 0 1 1 1v2M7 20H5a1 1 0 0 1-1-1v-2M17 20h2a1 1 0 0 0 1-1v-2"
            stroke={iconColor}
            strokeWidth={iconStroke}
            strokeLinecap="round"
          />
          
        </svg>
      </Box>
    </Box>

  );
}